import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import {gettext} from "../utils/text";

const queryStringGetSelectedFacets = () => {
    const query = queryString.parse(window.location.search.substr(1)) || [];

    /** @type {?Array<string>} */
    const selectedFacets = typeof query.selected_facets === "string" ?
        [query.selected_facets] : query.selected_facets;

    return {query, selectedFacets};
};

const Facet = ({facet}) => {
    // ex. species_exact:hamstrid
    const facetName = facet.split(':')[1];
    const onRemoveFacet = () => {
        const {query, selectedFacets} = queryStringGetSelectedFacets();
        query.selected_facets = selectedFacets.filter(
            f => f !== facet,
        );
        window.location.search = queryString.stringify(query);
    };
    const translatedFacetName = gettext(facetName);
    return (
        <span key={facetName} className="facet">
            <span className="facet-inner">
                <span className="facet-name">
                    <abbr title={translatedFacetName} className="facet-name-abbrv">{translatedFacetName}</abbr>
                </span>
                <i
                    className="icon icon--close facet-remove"
                    onClick={() => onRemoveFacet(facet)}
                />
            </span>
        </span>
    );
};

Facet.propTypes = {
    facet: PropTypes.string.isRequired,
};

const FacetCloud = () => {
    const {selectedFacets} = queryStringGetSelectedFacets();
    const onRemoveAllFacets = () => {
        // By removing all query parameters
        window.location.assign(window.location.pathname);
    };
    return selectedFacets ? (
        <div>
            <div>
                {Object.values(selectedFacets).map(f => <Facet key={f} facet={f} />)}
            </div>
            <a className="clear-facets" href="#" onClick={onRemoveAllFacets}>
                {gettext('Remove all filters')}
            </a>
        </div>
    ) : <div />;
};

export default FacetCloud;



// WEBPACK FOOTER //
// ./src/components/FacetCloud.js